import { AbstractControl, ValidationErrors } from "@angular/forms";

export const noSpecialCharactersValidator =
	(regex: string | RegExp, validationErrors = "noSpecialCharacters") =>
	(control: AbstractControl): ValidationErrors | null =>
		new RegExp(regex).test(control.value) ? null : { [validationErrors]: false };
